module.exports = __webpack_public_path__ + "static/media/S4ME.f1ff521b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/S4ME.jpg
// module id = 95
// module chunks = 0